const initialState = {
  socialsOpened: false,
  slidingDrawer: {
    commentsList: {
      paginationInfo: {}
    },
    reportMenu: {
      selectedCategoryId: null
    },
    currentContent: 'defaultWidth',
    opened: false,
    content: [],
    fetching: false,
    fetched: false,
    error: null
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_DRAWER_CONTENT': {
      return { ...state, slidingDrawer: { ...state.slidingDrawer, fetching: true, opened: true } };
    }
    case 'FETCH_REPORT_MENU_CONTENT_FULFILLED': {
      return { ...state, slidingDrawer: { ...state.slidingDrawer, content: action.payload, currentContent: 'reportMenu', commentsList: { paginationInfo: {} } } };
    }
    case 'FETCH_COMMENT_LIST_CONTENT_FULFILLED': {
      return { ...state,
        slidingDrawer: {
          ...state.slidingDrawer,
          content: action.payload.pop_comments,
          currentContent: 'commentList',
          commentsList: { paginationInfo: action.payload.meta.pagination_info }
        }
      };
    }
    case 'FETCH_MORE_COMMENTS_FULFILLED': {
      return { ...state,
        slidingDrawer: {
          ...state.slidingDrawer,
          content: [...state.slidingDrawer.content, ...action.payload.pop_comments],
          commentsList: { paginationInfo: action.payload.meta.pagination_info }
        }
      };
    }
    case 'FETCH_DRAWER_CONTENT_FULFILLED': {
      return { ...state, slidingDrawer: { ...state.slidingDrawer, fetching: false, fetched: true } };
    }
    case 'HIDE_DRAWER_CONTENT': {
      return { ...state, slidingDrawer: { ...state.slidingDrawer, opened: false } };
    }
    case 'SHOW_DRAWER_CONTENT': {
      return { ...state, socialsOpened: false, slidingDrawer: { ...state.slidingDrawer, opened: true, currentContent: action.payload } };
    }
    case 'HIDE_SOCIAL_DROPDOWN': {
      return { ...state, socialsOpened: false };
    }
    case 'SHOW_SOCIAL_DROPDOWN': {
      return { ...state, socialsOpened: true, slidingDrawer: { ...state.slidingDrawer, opened: false } };
    }
    case 'REPORT_CATEGORY_SELECTED': {
      return { ...state, slidingDrawer: { ...state.slidingDrawer, reportMenu: { selectedCategoryId: action.payload } } };
    }
  }
  return state;
};

export { initialState, reducer };
export default reducer;

